
        import {css} from 'lit-element';   
        export default css`:host .single-otp-input{width:51px;height:79px;border:2px solid #cacaca;border-radius:4px;opacity:1;margin-left:16px;text-align:center;font-size:42px;font-family:adobe-clean,sans-serif;color:#505050}@media(max-width: 768px){:host .single-otp-input{width:26px;height:45px;margin-left:10px;font-size:25px}}`;
    